import styled from "@emotion/styled";
import UI from "@mile-meeting/mile-ui";

const MeetingRoomCardSkeleton = () => {
  return (
    <Container className="meeting-room-card">
      <TitleContainer>
        <UI.Loading.Skeleton width="100%" height="24px" />
        <UI.Loading.Skeleton width="100%" height="22px" />
      </TitleContainer>
      <UI.Loading.Skeleton width="100%" height="22px" />
    </Container>
  );
};

export default MeetingRoomCardSkeleton;

const Container = styled.div`
  display: flex;
  min-width: 100px;
  max-width: 280px;
  box-sizing: border-box;
  width: 100%;
  padding: 0px 4px;
  flex-direction: column;
  gap: 4px;
`;

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  align-self: stretch;
`;
